<template>
  <v-dialog :value="showModal" @input="updateShowModal" max-width="500">
    <v-card>
      <v-card-title>{{ trans('booking.uncancel') }}</v-card-title>
      <v-card-text>
        <info-alert class="my-1">{{ trans('booking.uncancelHelp') }}</info-alert>
        <global-validation-errors class="mt-3" :value="validationErrors" />
        <form-input
          :label="trans('booking.settleDate')"
          v-model="uncancelBookingRequest.settleDate"
          type="date"
          date-type="month"
          cols-label="4"
          cols="8"
          :clearable="false"
          class="mt-3"
        >
        </form-input>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <cancel-button @click="updateShowModal(false)"></cancel-button>
        <save-button :loading="loading" @click="sendRequest" :label="trans('booking.uncancel')"></save-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CancelButton from './CancelButton'
import {LocaleUtils} from '../utils/locale-utils';
import {MainUtils} from '@/utils/main-utils';
import GlobalValidationErrors from '@/components/GlobalValidationErrors';
import SaveButton from './SaveButton';
import {BookingApi} from '@/api/booking-api';
import FormInput from '@/components/FormInput';
import InfoAlert from '@/components/InfoAlert';

export default {
  name: 'BookingUncancelModal',
  mixins: [
    MainUtils,
    LocaleUtils
  ],
  components: {InfoAlert, FormInput, SaveButton, GlobalValidationErrors, CancelButton},
  props: {
    showModal: {
      type: Boolean
    },
    /** @type {BookingDto} */
    booking: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      uncancelBookingRequest: {
        settleDate: null
      },
      validationErrors: {}
    }
  },
  methods: {
    sendRequest() {
      if(!this.loading) {
        this.loading = true;

        BookingApi.uncancelBooking(this.booking.id, this.uncancelBookingRequest)
          .then(() => {
            this.$emit('success');
            this.updateShowModal(false);
          })
          .catch((response) => this.validationErrors = this.getValidationErrors(response))
          .finally(() => {
            this.loading = false;
          });
      }
    },
    updateShowModal(value) {
      this.$emit('update:show-modal', value);
    }
  },
  watch: {
    showModal: {
      immediate: true,
      handler: function() {
        this.validationErrors = {};
      }
    },
    booking: {
      immediate: true,
      handler () {
        this.uncancelBookingRequest.settleDate = this.booking.settleDate;
      }
    }
  }
}
</script>
